/**
 * Axios API client with httpOnly cookie-based authentication
 * P1 SECURITY: Removed localStorage token storage to prevent XSS vulnerabilities.
 * Authentication is handled exclusively via httpOnly cookies set by the backend.
 */
import axios from 'axios';

export const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const apiClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // Required to send/receive httpOnly cookies
});

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Session cookie is invalid or expired
      // Redirect to login page for re-authentication
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
